const usersBackofficeRoutes = [
  {
    path: '',
    name: 'Users',
    meta: {
      title: {
        en: 'Users',
        ru: 'Пользователи',
      },
      authorize: [],
    },
    component: () => import(/* webpackChunkName: 'BackofficeUsers' */ '../components/pages/BackofficeUsers.vue'),
  },
  {
    path: ':_id',
    name: 'User Profile',
    meta: {
      title: {
        en: 'Profile Settings',
        ru: 'Настройки профиля',
      },
    },
    component: () => import(/* webpackChunkName: 'BackofficeUserProfileEdit' */ '../components/pages/ProfileEdit.vue'),
    children: [
      {
        path: '',
        // Явный child 'profile' вместо пустого пути: ProfileEditSidebar
        // ссылается на basePath + '/profile' во всех маунтах ProfileEdit.
        // Имя обязательно — addRoutes префиксует name безусловно. Redirect
        // функцией от фактического пути — см. getProfileEditChildren.
        name: 'Profile Edit Root',
        redirect: to => ({ path: to.path.replace(/\/$/, '') + '/profile' }),
      },
      {
        path: 'profile',
        name: 'Profile Edit Profile',
        component: () => import(/* webpackChunkName: 'BackofficeUserProfileEditProfile' */ '../components/pages/ProfileEditProfile.vue'),
      },
      {
        path: 'account',
        name: 'Profile Edit Account',
        component: () => import(/* webpackChunkName: 'BackofficeUserProfileEditAccount' */ '../components/pages/ProfileEditAccount.vue'),
      },
    ],
  },
];

export default usersBackofficeRoutes;
